import { faAlignLeft, faPrint } from '@fortawesome/free-solid-svg-icons';
import { FEATURES, isSomeFeaturesEnabled } from 'src/utils/features';
import routes from 'src/utils/routes';
import { getRouteURI } from 'src/utils/url';

export const PRINTER_PAGE_TAB = {
  WORKSTATION: 'workstation',
  QUEUE: 'queue',
};

export const PRINTER_PAGE_TABS = [
  { id: PRINTER_PAGE_TAB.WORKSTATION, label: 'Workstation', icon: faPrint },
  { id: PRINTER_PAGE_TAB.QUEUE, label: 'Run queue', icon: faAlignLeft },
];

export const arePrinterModulesEnabled = features =>
  isSomeFeaturesEnabled(features, [FEATURES.MATERIAL_MANAGEMENT, FEATURES.EQUIPMENT_MAINTENANCE]);

export const getPrinterPagePath = (uuid, isModular, features) =>
  getRouteURI(
    isModular ? routes.lpsPage : routes.printerMaterial,
    { uuid },
    arePrinterModulesEnabled(features) ? null : { tab: PRINTER_PAGE_TAB.QUEUE }
  );
